import { _404_TITLE } from 'mk/autogenerated/translations/NotFoundPage.ea6e35d6aa3308b8b7f9f52c8fb0c4e2'
import Loadable from 'mk2/helpers/Loadable';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page from 'mk2/pages/Page';
import { AppState } from 'mk2/reducers';
import * as React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

const NotFound = Loadable({
    loader: () => import('mk2/components/NotFound' /* webpackChunkName: "forum.NotFound" */),
    modules: ['mk2/components/NotFound'],
    webpack: () => [require.resolveWeak('mk2/components/NotFound')],
});

interface OwnProps {}
interface StateProps {}
interface DispatchProps {}
type RouteProps = RouteComponentProps<{}>;

type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export interface NotFoundOptions {
    defaultBackPath: string;
}

export default class NotFoundPage extends Page<OwnProps, StateProps, DispatchProps> {

    private options: NotFoundOptions;

    constructor(options: NotFoundOptions) {
        super();

        this.options = options;
    }

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => ({});
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {};
    }

    public getMetaTitle(props: Props): string {
        return _404_TITLE;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <NotFound {...props} header={false} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return this.options.defaultBackPath;
    }

}
